<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'organization_details', params: { orgId: orgId }}">organization
            </router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'customers'}">Access points</router-link>
          </div>
          <div class="text-xl text-primary">
            Access points
          </div>
        </div>
        <div class="">

        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="font-semibold mx-2 text-gray-600">{{ title }}</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="getHotspots(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">

          <table v-if="!loading" class="table-auto w-full">
            <thead>
            <tr class="border-b text-left">
              <th class="px-4 py-2 "></th>
              <th class="px-4 py-2 ">Name</th>
              <th class="px-4 py-2 ">Make</th>
              <th class="px-4 py-2">Mac address</th>
              <th class="px-4 py-2">Serial number</th>
              <th class="px-4 py-2">Clients</th>
              <th class="px-4 py-2">Connections</th>
              <th class="px-4 py-2">Online</th>
            </tr>
            </thead>
            <tbody>
            <tr class="border-b hover:bg-gray-200" v-for="(hotspot, index) in organization.accessPoints"
                :key="hotspot.id">
              <td class="px-3 py-2 font-bold">
                {{ offset + index + 1 }}
              </td>
              <td class="px-4 py-2 hover:text-blue-500">
                <router-link :to="{name: 'access_point', params: {apId: hotspot.id}}">{{ hotspot.name }}</router-link>
              </td>
              <td class="px-4 py-2">{{ hotspot.make }}</td>
              <td class="px-4 py-2">{{ hotspot.mac_address }}</td>
              <td class="px-4 py-2">{{ hotspot.serial_number }}</td>
              <td class="px-4 py-2">{{ hotspot.customersCount }}</td>
              <td class="px-4 py-2">{{ hotspot.connectionsCount }}</td>
              <td class="px-4 py-2">{{ hotspot.onlineConnectionsCount }}</td>
            </tr>
            </tbody>
          </table>
          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
        </div>
        <Pagination class="py-2 px-3" :total-count="organization.accessPointsCount" :current-page="currentPage"
                    :tag="'users'"
                    :offset="offset"
                    :records-count="organization.accessPoints != null ? organization.accessPoints.length || 0 : 0"
                    :click-handler="getHotspots" :records-per-page="parseInt(recordsPerPage)"/>
      </div>
    </div>
  </div>
</template>
<script>
import GraphQl from "@/services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "AccessPointsComponent",
  components: {Pagination},
  props: {
    filters: Object,
    breadcrumb: {default: true, type: Boolean},
    title: {type: String, default: 'Access points'},
    configs: Object,
    customers: {type: Array, default: () => []},
    venues: {type: Array, default: () => []},
    online: {type: Boolean, default: null},
    rowsPerPage: {type: Number, default: 10},
    authorized: {type: Boolean, default: null}
  },
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      organization: Object,
      orgId: this.$store.getters.orgId,
      currentPage: 1,
      loading: true
    }
  },
  mounted() {
    this.getHotspots();
  },
  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    getHotspots(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = (this.venues.length > 0 ? 'venues:["' + this.venues.join('","') + '"],' : '') +
          (this.online != null ? 'online:' + this.online + ',' : '') +
          (this.authorized != null ? 'authorized:' + this.authorized + ',' : '') +
          'limit: ' + this.recordsPerPage + ', ' +
          'offset: ' + this.offset + ', ' +
          'order: "created_at desc", ' +
          'search: "' + this.searchString + '"';
      GraphQl.sendRequest('{organization(id:"' + this.$store.getters.orgId + '") ' +
          '{accessPointsCount accessPoints(' + params + ') ' +
          '{id name mac_address serial_number status{status} onlineConnectionsCount customersCount connectionsCount make devicesCount}}}')
          .then(response => {
            this.organization = response.organization;
          }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style scoped>
</style>